import { render, staticRenderFns } from "./ProjectsSection.vue?vue&type=template&id=76a78481"
import script from "./ProjectsSection.vue?vue&type=script&lang=js"
export * from "./ProjectsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports